import {BaseModel} from '../base/BaseModel';

/**
 * @class FarmFeatures2Model
 * @extends BaseModel
 */
export class FarmFeatures2Model extends BaseModel {

    initialize () {

        this.microservice = 'users';
        this.resource = 'v2/farm-features';
    }

    defaults () {

        return  {
            farmUuid: undefined,
            cropUuid: undefined,
            name: undefined,
            validTill: undefined,
            packageUuid: undefined,
            packageType: undefined
        };
    }

    parse (response) {

        if (response) {

            if (_.isString(response.validTill)) {

                // Not using Farm specific timezone and ignoring timestamp
                response.validTill = moment(response.validTill.substring(0, 10));
            }
        }

        return response;
    }

    static get NAME () {

        return {
            TIMING: 'TIMING',
            MAPPING: 'MAPPING',

            MONITOR: 'MONITOR' // Only FE
        };
    }

    static get TYPE () {

        return {
            FOC: 'FOC',
            REGULAR: 'REGULAR',
            TECH: 'TECH'
        };
    }
}



// WEBPACK FOOTER //
// ./shared/model/users/FarmFeatures2Model.js